import styled from "styled-components";
import { Link } from "react-scroll";

// go to employee portal button in the navbar

export const Button = styled(Link)`
  border-radius: 50px;
  background: ${({ primary }) => (primary ? "#faed64" : "#010606")};
  white-space: nowrap;
  padding: ${({ big }) => (big ? "14px 48px" : "12px 30px")};
  color: ${({ dark }) => (dark ? "#010606" : "#010606")};
  font-size: ${({ fontBig }) => (fontBig ? "20px" : "16px")};
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    transition: all 0.2s ease-in-out;
    /* noted that this is not the best practice, but we really couldn't figure out why it won't work without it =( */
    text-decoration: none !important;
    color: black;
    background: ${({ primary }) => (primary ? "#fff" : "#faed64")} !important;
  }
`;
